import {
  Card,
} from 'material-ui/Card';
import Alert from 'react-s-alert';
import React, { Component } from 'react';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change, reset } from 'redux-form';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextField } from '../../../../components/reduxFields';
import { deleteUploadedDocument, documentUploadDownload, getMasterData, uploadedDocumentDownload, PreviewDownloadedDocument, getUserDocumentMasterFolderList, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments, deleteUserDocumentMasterFolder } from '../../../patients/actions/PatientActions';
//import PatientInfo from '../../patient_info';
import UploadDocumentModal from '../../../patients/patient_profile_client_modal';
import JPG from '../../../../img/jpg.png';
import DOC from '../../../../img/doc.png';
import EXCEL from '../../../../img/excel.png';
import OTHER from '../../../../img/other.png';
import PDF from '../../../../img/pdf.png';
import PNG from '../../../../img/png.png';
import PPT from '../../../../img/ppt.png';
import TXT from '../../../../img/txt.png';
import moment from 'moment';
import {base64Decode, alertConfirmation, showFormatedDate, isEmptyObject} from '../../../../actions/utilAction';
import MasterFoldersModal from './masterFolders_Modal';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import SortingCustom from '../../../../components/SortingCustom';
import PaginatorCustom from '../../../../components/paginationCustom';
import DocumentSubFolderList from './DocumentSubFolderList';
import MoveBatchDocumentsIntoFolderModal from './MoveBatchDocumentsIntoFolderModal';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class DocumentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openMasterFolder: false,      
      documentTypes: [],
      patientDocs: [],
      uploadDocumentObj: [],
      userId: null,
      masterFolderId: null,
      masterFolderIdForSubFolder: null,
      masterFolderName: '',
      isSubFolder: false,
      openBatchMoveModal: false,
      selectedDocumentIds: [],      
      userDocumentMasterFolders: [],
      userDocumentSubFolders: [],
      documentTypeId: 0,
      startDate: null,
      endDate: null,      
    };
    this.filter = {
      sort_Column: '',
      sort_order: '',     
      searchText: '',
    };
    this.handleCloseHandler = this.handleCloseHandler.bind(this);
    this.uploadDocumenthandler = this.uploadDocumenthandler.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleMasterFolderAlertClick = this.handleMasterFolderAlertClick.bind(this);
    this.handleEditMasterFolderClick = this.handleEditMasterFolderClick.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleMoveFolderDocumentClick = this.handleMoveFolderDocumentClick.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  loadData() {
    let searchObj = {
      userId: this.state.userId,
      fromDate: this.state.startDate ? moment(this.state.startDate).format('YYYY-MM-DD') : moment('1990-01-01').format('YYYY-MM-DD'),
      toDate: this.state.endDate ? moment(this.state.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      documentTypeId: this.state.documentTypeId,
      showOnlyExpiredDocuments: this.state.ShowOnlyExpiredDocuments ? true : false,      
      showOnlyInactiveDocuments: this.state.ShowOnlyInactiveDocuments ? true : false,  
      masterFolderId : null,
      subFolderId : null,
      searchText: this.filter.searchText || '',         
    };
    this.props.documentUploadDownload(searchObj); // For Listing of uploaded documents
  }

  loadMasterFolderData(page_number) {    
    let searchObj = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: 
      {         
        userId: this.state.userId,       
      },
    };

    this.props.getUserDocumentMasterFolderList(searchObj); // For Listing of Master Folders
  }

  componentWillMount() {
    let self = this.props ;    
    this.props.getMasterData('MASTERDOCUMENTTYPES,USERDOCUMENTMASTERFOLDER,USERDOCUMENTSUBFOLDER');
    this.setState({userId: self.user.userID},()=>{
      this.loadMasterFolderData();
      this.loadData();
      
    });    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.masterData && nextProps.masterData !== this.props.masterData) {
      this.setState({ documentTypes: nextProps.masterData.masterDocumentTypes });
      this.setState({ userDocumentMasterFolders: nextProps.masterData.userDocumentMasterFolder });
      this.setState({ userDocumentSubFolders: nextProps.masterData.userDocumentSubFolder });
    }
    if (nextProps.patientMasterData && nextProps.patientMasterData !== this.props.patientMasterData) {
      this.setState({ documentTypes: nextProps.patientMasterData.masterDocumentTypes });
    }
    if (nextProps.patientDocs && this.props.patientDocs !== nextProps.patientDocs) {
      this.setState({ patientDocs: nextProps.patientDocs });
    }
    
    if (nextProps.saved_userDocumentMasterFolder && nextProps.saved_userDocumentMasterFolder !== this.props.saved_userDocumentMasterFolder) {
      this.props.getMasterData('MASTERDOCUMENTTYPES,USERDOCUMENTMASTERFOLDER,USERDOCUMENTSUBFOLDER');
      this.loadMasterFolderData();
    }

    if (nextProps.saved_MoveBatchDocumentsIntoFolder && nextProps.saved_MoveBatchDocumentsIntoFolder !== this.props.saved_MoveBatchDocumentsIntoFolder) {
      this.ResetAllDocuments();
      this.loadMasterFolderData();
      this.loadData();
    }  
    
    if (nextProps.inactivated_MoveBatchDocuments && nextProps.inactivated_MoveBatchDocuments !== this.props.inactivated_MoveBatchDocuments) {      
      this.ResetAllDocuments();
      this.loadData();
    }  

    if (nextProps.deleted_MoveBatchDocuments && nextProps.deleted_MoveBatchDocuments !== this.props.deleted_MoveBatchDocuments) {
      this.ResetAllDocuments();
      this.loadData();
    }  

    if (nextProps.deleted_UserDocumentMasterFolder && nextProps.deleted_UserDocumentMasterFolder !== this.props.deleted_UserDocumentMasterFolder) {
      //this.ResetAllDocuments();
      this.loadMasterFolderData();
    }  
    
  }

    uploadDocumenthandler = () => {
      Alert.closeAll();
      this.setState({ open: true, uploadDocumentObj: null });
    }

    handleClose = () => {
      this.setState({
        openBatchMoveModal: false,
        selectedDocumentIds: [],      
      });
      // this.props.loadClaimsData();
      this.handleReset();
      this.props.dispatch(reset('DocumentListingForm', 'Chkclaim', null))
    }

    handleNewRequest(input, selectedRecord) {
      input.onChange(selectedRecord.value);      
      if (input.name === 'documentType') {
        this.setState({
          documentTypeId: selectedRecord.value,
        },()=>  this.loadData());
      } 
    }

    onDateChange(input, date) {
      //input.onChange(moment(date).format('MM/DD/YYYY'));
      input.onChange(moment(date).format());
        this.setState({ [input.name]: date }, () => {
            if (this.state.userId) {
              this.loadData();
            }
          });
    }

    handleReset() {
      this.props.dispatch(change('DocumentListingForm', 'startDate', null));
      this.props.dispatch(change('DocumentListingForm', 'endDate', null));
      this.props.dispatch(change('DocumentListingForm', 'documentType', null));
      this.props.dispatch(change('DocumentListingForm', 'ShowOnlyExpiredDocuments', false));
      this.props.dispatch(change('DocumentListingForm', 'ShowOnlyInactiveDocuments', false));    
      this.setState({
          ShowOnlyExpiredDocuments: false,
          ShowOnlyInactiveDocuments: false,
          documentTypeId: 0,
          startDate: null,
          endDate: null,
        },()=>{this.loadData()});
    };

    handleCloseHandler = () => {
      this.setState({ open: false, openMasterFolder: false });
    };

  handleDownloadClick = (docId, fileName) => {
    Alert.closeAll();
    this.props.uploadedDocumentDownload(docId, fileName);
  }

  handlePreviewClick = (docId, fileName) => {
    Alert.closeAll();
    this.props.PreviewDownloadedDocument(docId, fileName);
  }

  handleEditClick = (Obj) => {
    // console.log('Obj..............',Obj)
   this.setState({ open: true, uploadDocumentObj: Obj});
    Alert.closeAll();
  }

  onClickHandler = (e, obj) => {
    this.setState({
      masterFolderIdForSubFolder: obj.id,
      isSubFolder: true,
      folderName: obj.folderName
    })
    this.loadMasterFolderData();
  }

  onBackClick = () => {
      this.setState({
        masterFolderIdForSubFolder: null,
        isSubFolder: false,
        folderName: ''
      })
      this.loadMasterFolderData();
      this.loadData();
  }

  handleAlertClick = (docId) => {
    this.props.deleteUploadedDocument(docId, this.props.patientInfo.UserID);
    Alert.closeAll();
  }

  handleDeleteClick = (docId) => {
    let warningMsg = 'Are you sure you want to delete this document?';
    alertConfirmation(warningMsg, {
      customFields: {
        displayComponent: true,
        handleButtonClick: () => this.handleAlertClick(docId),
        id: docId,
      },
    });
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadData();
      });
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ openMasterFolder: true, masterFolderId: null });
  };

  handleEditMasterFolderClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ openMasterFolder: true, masterFolderId: obj.id });
  }

  handleMoveFolderDocumentClick = (event, Obj) => {
    Alert.closeAll();
    this.setState({
      openBatchMoveModal : true,
      selectedDocumentIds: Obj.documentIds.toString().trim()
    })
  }

  handleMasterFolderAlertClick = (event, masterFolderId) => {
      this.props.deleteUserDocumentMasterFolder(masterFolderId);
      Alert.closeAll();
  }

  handleDeleteMasterFolderClick = (event, obj) => {
      alertConfirmation('Are you sure you want to delete master folder?', {
          customFields: {
              displayComponent: true,
              handleButtonClick: this.handleMasterFolderAlertClick,
              id: obj.id,
          },
      });
  }

  CheckDocument(e, index, data) {  
    let selectedDocumentIds = this.state.selectedDocumentIds;

    let isDocumentChecked = e.target.checked;
    if (isDocumentChecked) {    
      selectedDocumentIds.push(data.id);
    } else {    
      index = selectedDocumentIds.findIndex((value) => value === data.id);
      if (index >= 0) {
        selectedDocumentIds.splice(index, 1);
      }
    }
    this.setState({ selectedDocumentIds });
  }

  handleMoveDocumentClick = () => {
    //console.log('selectedDocumentIds...........',this.state.selectedDocumentIds)
    this.setState({
      openBatchMoveModal : true
    })
  }

  ResetAllDocuments() {    
    if(!isEmptyObject(this.state.patientDocs))
    {
      let patientDocs = this.state.patientDocs;  
      patientDocs.forEach((obj, Index) => {
        let documentIdCheck = `Documents[${Index}].Chk`;
        this.props.dispatch(change('DocumentListingForm', documentIdCheck, false));
      });  
    }
    this.setState({ patientDocs:[], selectedDocumentIds : [] });
  }

  handleSelectAllClick= (e, isAllDocumentChecked) => {  
    let patientDocs = this.state.patientDocs;  
    let selectedDocumentIds = [];
    if(patientDocs && patientDocs.length > 0) {
      patientDocs.forEach((obj, Index) => {    
        let documentIdCheck = `Documents[${Index}].Chk`;
        if (obj && isAllDocumentChecked) {      
          selectedDocumentIds.push(obj.id);
          this.props.dispatch(change('DocumentListingForm', documentIdCheck, true));
        } else {
          this.props.dispatch(change('DocumentListingForm', documentIdCheck, false));
        }
      });
    }
    this.setState({  selectedDocumentIds });
  }

  closeDialog = () => {     
    this.setState({ openBatchMoveModal: false,  selectedDocumentIds: [] });
  }


  handleAlertInactiveDocumentsClick = (event) => {
    this.props.BatchInactiveDocuments(this.state.selectedDocumentIds.toString());
    Alert.closeAll();
  }

  handleBatchInactiveDocuments = (event) => {
    Alert.warning('Are you sure you want to inactive selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertInactiveDocumentsClick,
        //id: obj.id,
      },
    });
  }

  handleAlertActiveDocumentsClick = (event) => {
    this.props.BatchActiveDocuments(this.state.selectedDocumentIds.toString());
    Alert.closeAll();
  }

  handleBatchActiveDocuments = (event) => {
    Alert.warning('Are you sure you want to active selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertActiveDocumentsClick,
        //id: obj.id,
      },
    });
  }


  handleAlertDeleteDocumentsClick = (event) => {
    this.props.BatchDeleteDocuments(this.state.selectedDocumentIds.toString());
    Alert.closeAll();
  }

  handleBatchDeleteDocuments = (event) => {
    Alert.warning('Are you sure you want to delete selected documents?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertDeleteDocumentsClick,
        //id: obj.id,
      },
    });
  }


    renderDownloadDocs = () => {
      if ((this.state.patientDocs && this.state.patientDocs.length === 0) || (this.state.patientDocs.length === undefined)) {
        return (
          <div className="col-sm-4 mt20">
            <div className="familydl text-center no-record">
              No document found.
            </div>
          </div>
        );
      }
      let extension;
      if (this.state.patientDocs && this.state.patientDocs.length > 0) {
        // console.log('this.state.patientDocs-------', this.state.patientDocs);
        return this.state.patientDocs.map((obj, index) => {
          // console.log('obj----', obj);
          extension = obj.url.split('.').pop();
          let extensionArr = ['jpg', 'jpeg', 'png', 'txt', 'docx', 'doc', 'xlsx', 'pdf', 'pptx'];
          let fileExtensionCheck = extensionArr.find((o) => o === extension);
          if (fileExtensionCheck) {
            let imgUrl = '';
            if (fileExtensionCheck === 'jpg' || fileExtensionCheck === 'jpeg') {
              imgUrl = JPG;
            } else if (fileExtensionCheck === 'png') {
              imgUrl = PNG;
            } else if (fileExtensionCheck === 'txt') {
              imgUrl = TXT;
            } else if (fileExtensionCheck === 'pdf') {
              imgUrl = PDF;
            } else if (fileExtensionCheck === 'docx' || fileExtensionCheck === 'doc') {
              imgUrl = DOC;
            } else if (fileExtensionCheck === 'xlsx') {
              imgUrl = EXCEL;
            } else if (fileExtensionCheck === 'pptx') {
              imgUrl = PPT;
            } else {
              imgUrl = OTHER;
            }
            return (
              <div className="col-sm-6 history_card mt20" key={index}>
                <Card>
                <div className="cardchkbtn"> 
                  <Field
                    name={`Documents[${index}].Chk`}
                    component={renderCheckBox}
                    onChange={(e) => this.CheckDocument(e, index, obj)}
                    style={stylescss.checkbox}
                  />                  
                </div>
                <div className="clearfix"></div>
                  <div className="cardactbtn">
                    {this.props.deletePermission ?
                      <button onClick={(e) => this.handleEditClick(obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                    : null}
                    {this.props.downloadPermission ?
                      <button onClick={(e) => this.handlePreviewClick(obj.id, obj.url)} type="button" title="Preview" className="tbactionbtn bluefont"><i className="fa fa-eye" aria-hidden="true"></i></button>
                      : null}
                    {this.props.downloadPermission ?
                      <button onClick={(e) => this.handleDownloadClick(obj.id, obj.url)} type="button" title="Download" className="tbactionbtn bluefont"><i className="fa fa-download" aria-hidden="true"></i></button>
                      : null}
                    {this.props.deletePermission ?
                      <button onClick={(e) => this.handleDeleteClick(obj.id)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                      : null}
                    <div className="filetype">
                      <img src={imgUrl} alt="text" title={obj.url} />
                    </div>
                  </div>
                  <div className="carditems">
                    <ul>
                      <li>Document Title: <span>{obj.documentTitle}</span></li>
                      <li>Document Type: <span>{obj.documentTypeName}</span> </li>
                      <li>Uploaded Date: <span>{showFormatedDate(obj.createdDate || new Date())}</span></li>
                      {!obj.expiration ? <li>Expiration Date: <span>No Expiration</span> </li> : <li>Expiration Date: <span>{moment(obj.expiration).format('MM/DD/YYYY')}</span></li> }
                      <li>Active Document: <span className={obj.isActive === true ? 'greenfont' : 'redfont'}>{obj.isActive ? 'Yes' : 'No'}</span></li>
                    </ul>
                  </div>
                </Card>
              </div>
            );
          }
        });
      }
    }

    renderDocumentListingPanel() {
      return (
        <div>
          {!this.state.isRedirectFromUserProfile && this.state.isSubFolder === false &&
                  (<div>
                    <div className="row">                      
                      <div className="col-sm-4">
                        <Field
                          name="startDate"
                          placeholder="From Date"
                          locale="en-US"
                          onDateChange={this.onDateChange}
                          selected={this.state.startDate}
                          component={renderDateField}/>
                      </div>
                      <div className="col-sm-4">
                        <Field
                          name="endDate"
                          placeholder="To Date"
                          locale="en-US"
                          onDateChange={this.onDateChange}
                          selected={this.state.endDate}
                          component={renderDateField}/>
                      </div>                  
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                            <Field
                              name="patientDocs"
                              floatingLabelText="Search"
                              maxLength='25'
                              onChange={this.handleSearchChange}
                              component={renderTextField}
                            />
                        </div>
                      <div className="col-sm-4 mt-30">
                        <Field
                            name="documentType"
                            label="Document Type"
                            component={renderAutoCompleteSingleSelect}
                            options={this.state.documentTypes}
                            handleNewRequest={this.handleNewRequest}
                          />
                      </div>
                      <div className="col-sm-4 mt-30">
                          <Field
                              name="ShowOnlyExpiredDocuments"
                              label="Show expired documents only"
                              component={renderCheckBox}
                              onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyExpiredDocuments')}
                            />
                      </div>      
                    </div>      
                    <div className="row">
                      <div className="col-sm-4 mt-30">
                          <Field
                              name="ShowOnlyInactiveDocuments"
                              label="Show inactive documents only"
                              component={renderCheckBox}
                              onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyInactiveDocuments')}
                            />
                      </div>                        
                      <div className="col-sm-6 mt-30"></div>
                      <div className="reset-btn col-sm-2 mt-30 btn_rt">
                        <CommonButton className="grey_btn" onTouchTap={this.handleReset} label = 'Reset' />
                      </div>                  
                  </div>
                </div>)}
                {this.props.uploadPermission && this.state.isSubFolder === false ?
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 reset-btn claims_btn">
                        <CommonButton className="mt-20" label="Upload Document" primary={true} onTouchTap={this.uploadDocumenthandler} />
                        {/* <RaisedButton className={"grey_btn ml_15"}  onTouchTap={(e) => this.handleSelectAllClick(e, (this.state.selectedDocumentIds.length > 0  ? false : true))} >{this.state.selectedDocumentIds.length > 0 ? "Deselect All" : "Select All"}</RaisedButton> */}
                        {/* <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleMoveDocumentClick(e)} >Bulk Move Documents</RaisedButton> */}
                        {/* <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchInactiveDocuments(e)} >Bulk Inactive Documents</RaisedButton> */}
                        {/* <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchActiveDocuments(e)} >Bulk Active Documents</RaisedButton> */}
                        {/* <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchDeleteDocuments(e)} >Bulk Delete Documents</RaisedButton> */}
                    </div>
                  </div>
                : null}                 
          <div className="row">        
            {this.state.userId ?  this.state.isSubFolder === false ? this.masterFoldersRender() : 
                      <DocumentSubFolderList
                      masterFolderIdForSubFolder={this.state.masterFolderIdForSubFolder}  
                      masterFolderName={this.state.folderName}
                      userId={this.state.userId}
                      staffId={this.state.staffId}
                      onBackClick={this.onBackClick}/>
            : null}
            <div className="clearfix"></div>
            {!this.state.userId ?
              (<div className="col-sm-12 mt20">
                <div className="familydl text-center no-record">
                      No staff selected.
                </div>
              </div>)
              : 
              this.state.isSubFolder === false && this.renderDownloadDocs() 
            }
  
            
          </div>
        </div>
      );
    }


    masterFoldersRender = () => {
      const { handleSubmit, userDocumentMasterFolderData } = this.props;
      let userDocumentMasterFolderList = (userDocumentMasterFolderData && userDocumentMasterFolderData.data) || [];
      let userDocumentMasterFolderMeta = (userDocumentMasterFolderData && userDocumentMasterFolderData.meta) || null
      const tableClass = classNames({
          'table': true,
          'table-striped': this.props.condensed,
          'table-bordered': this.props.bordered,
          'table-hover': true,
          'table-condensed': this.props.condensed,
          'customtable': true,
      });
      return (
          <div className="col-sm-12">
          {/* <h2 className="page_title">Manage Master Folders</h2>
          <div className="clearfix"></div> 
          <div className="readmin-panel">*/}
              <div className="panel-body">
                  <div className="modalwindow">
                      <div className="row">
                          {/* <div className="col-sm-5">
                              {this.props.uploadPermission ? 
                                <div>
                                    <RaisedButton label="Add Master Folder" primary={true} onTouchTap={this.handleOpen} />
                                </div>
                              : null}
                          </div> */}
                          {/* <div className="col-sm-7">
                              <div className="row end-flex">
                                  <div className="col-sm-6 mtm-27">
                                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchCurriculumLibraries)}>
                                          <Field
                                              name="curriculumLibraries"
                                              floatingLabelText="Search"
                                              maxLength='25'
                                              onChange={this.handleSearchChange}
                                              component={renderTextField}
                                          />
                                      </form>
                                  </div>
                                  <div className="reset-btn col-sm-3 btn_rt">
                                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                  </div>
                              </div>
                          </div> */}
                      </div>                    
                      {this.state.openMasterFolder && <MasterFoldersModal userId={this.state.userId} userTypeName = "PATIENT" masterFolderId={this.state.masterFolderId} closeDialog={this.handleCloseHandler} />}        
                  </div>
                  <div className="row">
                      <div className="col-sm-12">
                          <div className="table-responsive mt-15">
                              <table className={tableClass}>
                                  <thead>
                                      <tr>
                                          <th width="50%"><SortingCustom noSort={!userDocumentMasterFolderList.length} setSortColumn={this.setSortColumn} columnName='folderName' displayName='Name' /></th>
                                          <th width="50%">Active</th>
                                           {/* {this.props.uploadPermission  ? 
                                              <th width="20%">Actions</th>
                                               : null
                                            } */}
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {this.renderData(userDocumentMasterFolderList)}
                                  </tbody>
                              </table>
                              {userDocumentMasterFolderMeta && userDocumentMasterFolderMeta['totalPages'] ?
                                  <PaginatorCustom data={userDocumentMasterFolderMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                  : null}
                          </div>
                      </div>
                  </div>
              </div>
          {/* </div> */}
      </div>
      )
  }

  renderData(userDocumentMasterFolderList) {
    userDocumentMasterFolderList = userDocumentMasterFolderList || [];
    if (!userDocumentMasterFolderList.length) {
        return (
            <tr>
                <td colSpan="2">
                    <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No folder found.'}</div>
                </td>
            </tr>
        );
    }
    return userDocumentMasterFolderList.map((Obj, index) => {
        return (
            <tr key={index}>
                <td><a href="#" onClick={(e) => this.onClickHandler(e, Obj)}>{Obj.folderName}</a></td>              
                <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                {/* {this.props.uploadPermission ?
                    <td>
                        <button onClick={(e) => this.handleEditMasterFolderClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        {Obj.documentIds.toString().trim() !== '' && <button onClick={(e) => this.handleMoveFolderDocumentClick(e, Obj)} type="button" title="Move All Documents" className="tbactionbtn bluefont"><i className="fa fa-arrow-up" aria-hidden="true"></i></button>}                        
                    </td>
                    : null } */}
            </tr>
        )
    })
  }

  render() {
    return (
      <div className="row">
        {this.state.open ? <UploadDocumentModal uploadDocumentObj={this.state.uploadDocumentObj} UserID={this.state.userId} closeDialog={this.handleCloseHandler} documentTypes={this.state.documentTypes}  userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId  && obj.userTypeName === 'PATIENT')} userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)} /> : ''}       
        {!this.state.isRedirectFromUserProfile ?
          (<div className="col-sm-12">
            <h2 className="page_title">Document Upload</h2>
            {/* <PatientInfo patientId={this.props.patientId} /> */}
            <div className="clearfix"></div>
            <div className="readmin-panel">
              <div className="panel-body">
                {this.renderDocumentListingPanel()}
              </div>
            </div>
          </div>)
          :
          (<div className="col-sm-12">
            {this.renderDocumentListingPanel()}
          </div>)}

          {
            this.state.openBatchMoveModal === true && <MoveBatchDocumentsIntoFolderModal
            selectedDocumentIds={this.state.selectedDocumentIds}
            userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId  && obj.userTypeName === 'PATIENT')}
            userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)}
            closeDialog={this.closeDialog}
            />
          }
      </div>
    );
  }
}
DocumentList = reduxForm({
  form: 'DocumentListingForm',
})(DocumentList);
const selector = formValueSelector('DocumentListingForm');
function mapStateToProps(state, ownProps) {
// debugger;
   let uploadPermission = false;
  //  selectorStartDate = selector(state, 'startDate'),
  //  selectorEndDate = selector(state, 'endDate');
  let patientId;
  if (state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.roleName === 'Client') {
      patientId = state.login.loginUserInfo.id;
      uploadPermission= state.login.loginUserInfo.isUploadClientDocuments ? true : false;
  } else {
      patientId = state.patient.patientId;
  }

  return {
    loading: state.patient.loading,
    patientMasterData: state.patient.master_data,
    patientDocs: state.patient.patientDocumentDownload,
    delete_Uploaded_Document: state.patient.delete_Uploaded_Document,
    uploadPermission: uploadPermission,
    downloadPermission: true,
    deletePermission: false,
    patientInfo: state.patient.patientInfo, // user ID for documnets
    masterData: state.user.master_data,
    userDocumentMasterFolderData: state.patient.userDocumentMasterFolderList,
    saved_userDocumentMasterFolder: state.patient.saved_userDocumentMasterFolderList,
    saved_MoveBatchDocumentsIntoFolder: state.patient.saved_MoveBatchDocumentsIntoFolder,    
    inactivated_MoveBatchDocuments: state.patient.inactivated_MoveBatchDocuments,    
    deleted_MoveBatchDocuments: state.patient.deleted_MoveBatchDocuments,  
    deleted_UserDocumentMasterFolder: state.patient.deleted_UserDocumentMasterFolder, 
    patientId: patientId,      
    // selectorStartDate,
    // selectorEndDate,
  };
}


export default connect(mapStateToProps, { getMasterData, documentUploadDownload, uploadedDocumentDownload, deleteUploadedDocument, PreviewDownloadedDocument, getUserDocumentMasterFolderList, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments, deleteUserDocumentMasterFolder })(DocumentList);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/uploadDocuments/documentList.js